module.exports = __webpack_public_path__ + "img/notime.a6ffd0e7.jpg";